/* eslint-disable linebreak-style */
/* eslint-disable no-param-reassign */
import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import AabSelect from '@aab/sc-aab-select/src/AabSelect';
import AabInputblockNumeric from '@aab/sc-aab-inputblock-numeric/src/AabInputblockNumeric';

import { sy_arrow_chevron_leftlarge as syArrowChevronLeft, sy_arrow_chevron_rightlarge as syArrowChevronRight } from '@aab/sc-aab-icon-set';
import styles from './styles';

export default class AabPagination extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.totalItems = 0;
    this.itemsPerPage = [25, 50, 100];
    this.selectedPageItem = 0;
    this.selectedPageNumber = 1;
    this.totalPages = 1;
    this.background = false;
    this.smallWidth = false;
    this.addEventListener('aab-inputblock-change', this.pageChangeEvent);
    this.addEventListener('aab-select-value-selected', this.itemsPerPageUpdated);
  }

  static get properties() {
    return {
      totalItems: {
        type: Number,
        attribute: 'total-items',
        reflect: true,
      },
      itemsPerPage: {
        type: Array,
        attribute: 'items-per-page',
        reflect: true,
      },
      selectedPageItem: {
        type: Number,
        attribute: 'selected-page-item',
        reflect: true,
      },
      selectedPageNumber: {
        type: Number,
        attribute: 'selected-page-number',
        reflect: true,
      },
      background: {
        type: Boolean,
        attribute: 'background',
        reflect: true,
      },
      smallWidth: {
        type: Boolean,
        attribute: 'small-width',
        reflect: true,
      },
      selectedLanguage:{
        type: String,
        attribute: 'selected-language',
        reflect:true
      }

    };
  }

  static get scopedElements() {
    return {
      'aab-icon': AabIcon,
      'aab-select': AabSelect,
      'aab-inputblock-numeric': AabInputblockNumeric,
    };
  }

  static get styles() {
    return styles;
  }
  pageChangeEvent(inputBoxEvent) {
    this.selectedPageNumber = inputBoxEvent.detail.value === '' ? 1 : inputBoxEvent.detail.value;
    if (this.selectedPageNumber <= 1) {
      this.selectedPageNumber = 1;
      inputBoxEvent.detail.value = 1;
    }
    if (this.selectedPageNumber >= this.totalPages) {
      this.selectedPageNumber = this.totalPages;
    }
    inputBoxEvent.detail.srcElement.value = parseInt(this.selectedPageNumber, 10);
    this.updatePageComponent();
  }
  itemsPerPageUpdated(selectBoxEvent) {
    this.selectedPageItem = selectBoxEvent.detail.value;
    this.selectedPageNumber = 1;
    this.getUpdatedTotalPages();
    this.updatePageComponent();
  }
  getUpdatedTotalPages() {
    this.totalPages = this.totalItems % this.selectedPageItem === 0 ? parseInt(this.totalItems / this.selectedPageItem,10) : parseInt(this.totalItems / this.selectedPageItem,10) + 1;
    return this.totalPages;
  }
  incrementPageNumber() {
    if (this.selectedPageNumber < this.totalPages) {
      this.selectedPageNumber = parseInt(this.selectedPageNumber, 10) + 1;
    }
    this.updatePageComponent();
  }
  decrementPageNumber() {
    if (this.selectedPageNumber >= 2) {
      this.selectedPageNumber -= 1;
    }
    if (this.selectedPageNumber === 1) {
      this.selectedPageNumber = 1;
    }
    this.updatePageComponent();
  }
  updatePageComponent() {
    const value = {
      pageNumber: this.selectedPageNumber,
      itemsPerPage: this.selectedPageItem,
    };
    const eventObj = new CustomEvent('aab-pagination-updated', {
      detail: {
        value,
      },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(eventObj);
  }

  render() {
    const options = this.itemsPerPage;
    const indexOfSelectedData = options.indexOf(this.selectedPageItem);
    const showPageLabel = this.selectedLanguage==='nl' ? 'Toon': 'show';
    const goToPageLabel = this.selectedLanguage==='nl' ? 'Naar pagina': 'Go to page';
    const pageLabel = this.selectedLanguage==='nl' ? 'Pagina': 'Page';
    const pageIndicationLabel = this.selectedLanguage==='nl' ? ' van ': ' of ';
    const perPageLabel = this.selectedLanguage==='nl' ? 'per pagina': 'per page';
    const forSmallScreen = window.matchMedia('(max-width: 480px)');
    this.smallWidth = this.smallWidth || forSmallScreen.matches;
    const dropdownLabel = this.smallWidth ? showPageLabel : perPageLabel;
    const pageNumberLabel = this.smallWidth ? pageLabel : goToPageLabel;

    return html`
      <div class="${this.background ? 'bg-white-me ' : ''} pagination-container d-flex align-items-center px-2">
        <div class="${this.smallWidth ? 'side-panel-pagination ' : ''} pagination-left-pane text-left pl-1 d-inline-block">
            <span class="d-flex component-container ${this.smallWidth ? 'flex-column-reverse' : 'align-items-center flex-row'}">
                <aab-select class="dropdown-width d-inline-block ${this.smallWidth ? 'smy--2 ml-0' : ''}" 
                .value="${options[indexOfSelectedData] >=0 ? options[indexOfSelectedData]:options[0]}" 
                .options=${options}>
                </aab-select>
                <span class="${this.smallWidth ? 'pb-1' : 'ml-1'} ">${dropdownLabel}</span>
            </span>
        </div>
        <div class="${this.smallWidth ? 'side-panel-pagination ' : ''} pagination-right-pane d-flex ml-1">
            <div class="d-flex component-container ml-auto ${this.smallWidth ? 'text-left flex-column' : 'flex-row align-items-center'}">
              <span class=" ${this.smallWidth ? 'pb-1 ml-1' : ''} mr-1" id="input-text">${pageNumberLabel}</span>
              <aab-inputblock-numeric class="input-component-width d_inline_block ml-1" input-type="number"
                value="${this.selectedPageNumber}" input-id="pageNumberSelected">
              </aab-inputblock-numeric>
            </div>
            <div class="page-button-container ml-3 d-flex ${this.smallWidth ? 'text-left flex-column' : 'align-items-center flex-row'}">
                <span class="${this.smallWidth ? 'pb-1' : 'ml-1'}">${this.selectedPageNumber} ${pageIndicationLabel} ${this.getUpdatedTotalPages()}</span>
                <div class="d-flex">
                  <div class="pagination-button ml-1 align-items-center rounded-left-2" @click="${() => this.decrementPageNumber()}">
                      <aab-icon svg="${syArrowChevronLeft}" size="3"></aab-icon>
                  </div>
                  <div class="pagination-button align-items-center rounded-right-2" @click="${() => this.incrementPageNumber()}">
                      <aab-icon  svg="${syArrowChevronRight}" size="3"></aab-icon>
                  </div>
                </div>
            </div>
        </div>
      </div>
    `;
  }
}
